export default "__VITE_ASSET__xMs5dJik__"